import React from "react";

const Temperature = (props) => {
  return (
    <div className="box">
      <h2>Temperature </h2>
      <div>
        {4 > 3 ? (
          <div>
            <h1 className="orange">5°C</h1>
          </div>
        ) : (
          <h1 className="blue">OFF</h1>
        )}
      </div>
    </div>
  );
};

export default Temperature;
